<template>
  <app-panel>
    <label slot="panel-header">
      {{ $t('alarm-configurations.query.filters-title') }}
    </label>
    <div
      class="alarm-configurations__filter-panel pl-2 pr-2"
      slot="panel-body"
    >
      <b-form novalidate>
        <b-form-row class="alarm-configurations__form-row mb-3">
          <b-col
            sm="12"
            md="6"
          >
            <b-form-group>
              <label> {{ $t('alarm-configurations.query.module') }}
              </label>
              <s-select
                v-model="filters.moduleId"
                text-field="name"
                value-field="id"
                :options="modules"
              />
            </b-form-group>
          </b-col>
          <b-col
            :md="6"
            sm="12"
          >
            <b-form-group>
              <label> {{ $t('alarm-configurations.query.classification') }}
              </label>
              <s-select
                v-model="filters.alarmClassification"
                :options="classifications"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="hasExhibitionPermission"
            sm="12"
            md="6"
          >
            <b-form-group>
              <label> {{ $t('alarm-configurations.query.exhibition') }}
              </label>
              <s-select
                v-model="filters.display"
                :options="exhibitions"
              />
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-checkbox
          v-model="showAdvancedFilters"
          class="mb-3 ml-2"
        > {{ $t('alarm-configurations.query.advanced-filters') }}
        </b-form-checkbox>
        <b-form-row
          v-show="showAdvancedFilters"
          class="alarm-configurations__form-row"
        >
          <reports-filter
            class="ml-2"
            ref="reportsFilter"
            :filter.sync="advancedFilters"
          />
        </b-form-row>
        <b-row
          class="alarm-configurations__form-row"
          align-h="end"
        >
          <b-col
            class="p-0 mt-2"
            sm="12"
            md="auto"
          >
            <b-button
              class="alarm-configurations__filters-buttons"
              block
              @click="cleanAllFilters"
            > {{ $t('general.clean-filters') }}
            </b-button>
          </b-col>
          <b-col
            class="pr-0 mt-2 pl-0 pl-md-2"
            sm="12"
            md="auto"
          >
            <b-button
              class="alarm-configurations__filters-buttons"
              block
              variant="primary"
              @click="search"
            > {{ $t('general.search') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </app-panel>
</template>

<script>
import { AlarmClassificationType } from 'sigma-mappings';
import ModuleService from '@/domain/services/module';
import ReportsFilter from '@/components/ReportsFilter';

export default {
  name: 'AlarmsFilter',
  components: {
    ReportsFilter,
  },
  data: () => ({
    modules: [],
    showAdvancedFilters: false,
    filters: {
      moduleId: null,
      alarmClassification: null,
      display: null,
    },
    advancedFilters: {
      companiesIds: null,
      regionalIds: null,
      installationsIds: null,
      assetsIds: null,
    },
  }),
  computed: {
    exhibitions() {
      return [
        {
          value: null,
          text: this.getText('all-o'),
        }, {
          value: false,
          text: this.getText('only-hidden-option'),
        }, {
          value: true,
          text: this.getText('except-hidden-option'),
        },
      ];
    },
    classifications() {
      return [
        {
          value: null,
          text: this.getText('all-a'),
        }, {
          value: AlarmClassificationType.ORDINARY,
          text: this.getText('ordinary'),
        }, {
          value: AlarmClassificationType.URGENT,
          text: this.getText('urgent'),
        }, {
          value: AlarmClassificationType.CRITICAL,
          text: this.getText('critical'),
        },
      ];
    },
    hasExhibitionPermission() {
      return this.$hasUserPermission('PER005');
    },
  },
  created() {
    this.listModules();
  },
  methods: {
    getText(key) {
      return this.$t(`alarm-configurations.query.${key}`);
    },
    clearFilters() {
      this.filters = {
        moduleId: null,
        alarmClassification: null,
        display: null,
      };
    },
    clearAdvancedFilters() {
      this.$refs.reportsFilter.clearAllFilters();
      this.advancedFilters = {
        companiesIds: null,
        regionalIds: null,
        installationsIds: null,
        assetsIds: null,
      };
    },
    listModules() {
      ModuleService.getModulesLinkedToAlarms()
        .then((response) => {
          this.modules = [
            this.blankItem('all-o'),
            ...response,
          ];
        });
    },
    search() {
      let allFilters = {};
      allFilters = {
        ...this.advancedFilters,
        ...this.filters,
      };
      if (!this.showAdvancedFilters) {
        allFilters = {
          ...allFilters,
          companiesIds: null,
          regionalIds: null,
          installationsIds: null,
          assetsIds: null,
        };
      }
      this.$emit('search', allFilters);
    },
    cleanAllFilters() {
      this.showAdvancedFilters = false;
      this.clearFilters();
      this.clearAdvancedFilters();
      this.listModules();
      this.search();
    },
    blankItem(key, value = null) {
      return {
        id: value,
        name: this.getText(key),
      };
    },
  },
};
</script>

<style lang="sass" scoped>
  .alarm-configurations
    &__filter-panel
      display: flex
      flex-direction: column
      padding: 10px
    &__form-row
      margin: 0
      width: 100%
  ::v-deep
    .app-panel__body
      overflow: visible !important
</style>
